var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQRscanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        opacity: 0;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #858585;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13693",
    "data-name": "Group 13693",
    transform: "translate(-1973 -3472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13692",
    "data-name": "Group 13692"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4573",
    "data-name": "Rectangle 4573",
    className: "cls-1",
    width: 45,
    height: 45,
    transform: "translate(1973 3472)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_12",
    "data-name": "Union 12",
    className: "cls-2",
    d: "M28.381,37.59V34.557h6.177V28.381H37.59v9.21ZM0,37.59v-9.21H3.033v6.177H9.21V37.59ZM20.954,31.8V20.954H31.8V31.8Zm2.8-2.8h5.254V23.752H23.752ZM10.711,31.8V29.342H9.248V31.8H5.786V28.342H8.248V26.878H5.786V23.416H8.248V20.954h3.463v2.462h1.462V20.954h3.462v3.462H14.174v1.462h2.462v3.463H14.174V31.8Zm1-3.462h1.462V26.878H11.712ZM9.248,25.879h1.462V24.416H9.248Zm11.705-9.242V5.786H31.8v10.85Zm2.8-2.8h5.254V8.584H23.752Zm-17.966,2.8V5.786h10.85v10.85Zm2.8-2.8h5.254V8.584H8.584ZM34.557,9.21V3.033H28.381V0h9.21V9.21ZM0,9.21V0H9.21V3.033H3.033V9.21Z",
    transform: "translate(1976.721 3475.721)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQRscanner);
export default __webpack_public_path__ + "static/media/QR scanner.48dce4b9a830a85b16a25d003dd5c5c0.svg";
export { ForwardRef as ReactComponent };